import { memo } from 'react';
import Image from 'next/image';
import classNames from 'classnames';
import { BlogCategoryTag } from '@components/BlogCategoryTag';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { AuthorDetails } from '@components/AuthorDetails';
import styles from './styles.module.scss';
import { IBlogCardProps } from './BlogCard.types';

export const BlogCard = memo<IBlogCardProps>(
  ({
    title,
    description,
    categories,
    publishedAt,
    readTime,
    imageUrl,
    className,
    slug,
    author,
  }) => {
    const router = useRouter();

    return (
      <Link href={`/blog/${slug}`} className={classNames(styles.card, className)}>
        <Image
          className={styles.mainImage}
          src={imageUrl}
          alt="Hero Banner"
          width={0}
          height={0}
          sizes="100vw"
          loading="lazy"
        />
        <div className={styles.rubric}>
          <div className={styles.categoryList}>
            {categories.map(({ title: categoryTitle, slug: categorySlug }) => (
              <BlogCategoryTag
                isLink={false}
                onClick={(e) => {
                  e.preventDefault(); // NOTE: Prevents navigating to the parent href in <Link>
                  router.push(`/blog/tag/${categorySlug}`);
                }}
                key={categoryTitle}
                label={categoryTitle}
                className={styles.categoryItem}
              />
            ))}
          </div>
        </div>
        <div className={styles.content}>
          <h4>{title}</h4>
          <span className={styles.subtitle}>{description}</span>
          <AuthorDetails {...author} readTime={readTime} publishedAt={publishedAt} />
        </div>
      </Link>
    );
  },
);
BlogCard.displayName = 'BlogCard';

export default BlogCard;
